import Popover from "molecule/popover/Popover";
import styled from "@emotion/styled";
import type { FC } from "react";
import React, { useRef } from "react";
import { useButton, useOverlayTrigger } from "react-aria";
import { useOverlayTriggerState } from "react-stately";
import { IconClose } from "src/constants/icons";
import translate from "src/lib/translate";
import Translate from "../Translate/Translate";

const Trigger = styled.button`
  min-height: 44px;
  min-width: 44px;
  padding: 0;
  border: 0;
  background: none;
  color: inherit;
  font: inherit;
  font-weight: 500;
  cursor: pointer;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border: 0;
  border-radius: 8px;
  background: var(--color-cream);
  cursor: pointer;
`;

const Content = styled.div`
  position: relative;
  max-width: min(400px, 90vw);
  padding: var(--space-lg, 32px);
  border-radius: 9px;
  background: var(--color-cream-dark);
  box-shadow: var(--light-shadow);

  h5 {
    margin: 0;
    font-weight: 700;
  }

  p {
    margin: 8px 0 0;
  }
`;

const HeaderHelp: FC = () => {
  const ref = useRef<HTMLButtonElement>(null);
  const state = useOverlayTriggerState({});
  const { triggerProps, overlayProps } = useOverlayTrigger(
    { type: "dialog" },
    state,
    ref
  );
  const { buttonProps } = useButton(triggerProps, ref);

  return (
    <>
      <Trigger {...buttonProps} ref={ref}>
        <Translate msg="help.question" />
      </Trigger>
      {state.isOpen && (
        <Popover
          title={translate("help.questions")}
          state={state}
          triggerRef={ref}
          placement="bottom end"
        >
          <Content {...overlayProps}>
            <CloseButton
              type="button"
              aria-label={translate("close")}
              onClick={() => state.close()}
            >
              <IconClose />
            </CloseButton>
            <h5>
              <Translate msg="help.questions" />
            </h5>
            <p>
              <Translate msg="help.phoneSupport" />{" "}
              <a href="tel:2029329958">(202) 932-9958</a>
              <br />
              <Translate msg="help.emailSupport" />{" "}
              <a href="mailto:support@join9am.com">support@join9am.com</a>
            </p>
          </Content>
        </Popover>
      )}
    </>
  );
};

export default HeaderHelp;
